import { FIELD_PATHS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { DollarInputField } from '../../Fields';

interface EmploymentIncomeAmountProps extends IncomeEntityIndex {
  label?: string;
  isDisabled?: boolean;
  isOptional?: boolean;
  disableFailMessage?: boolean;
}

export const EmploymentIncomeAmount = (props: EmploymentIncomeAmountProps) => {
  const { incomeIndex, ...rest } = props;

  return <DollarInputField {...rest} name={FIELD_PATHS.INCOME_AMOUNT(incomeIndex)} />;
};
